<template>
  <div class="search-container">
    <div class="search-tabs">
      <div
        class="search-tab"
        v-for="tab in searchTabs"
        :key="tab.value"
        :class="{ active: restockStatus === tab.value }"
        @click="searchChange(tab.value)"
      >
        <span>{{ tab.label }}</span>
        <span class="badge">{{ tab.badge }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { add } from '@/libs/util.number.js'
export default {
  props: {
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return {
      restockStatus: '',
      normalCount: 0,
      partRestockCount: 0,
    }
  },
  computed: {
    totalCount() {
      return add(this.normalCount, this.partRestockCount)
    },
    searchTabs() {
      return [
        {
          label: this.$l('btn_all') || '全部',
          value: '',
          badge: this.totalCount,
        },
        {
          label: this.$l('btn_normal') || '正常补货',
          value: 'Y',
          badge: this.normalCount,
        },
        {
          label: this.$l('btn_partRestock') || '部分补货',
          value: 'P',
          badge: this.partRestockCount,
        },
      ]
    },
  },
  mounted() {
    this.getNormalCount()
    this.getPartRestockCount()
  },
  methods: {
    searchChange(value = '') {
      this.restockStatus = value
      this.$emit('change', '')
    },
    async getNormalCount() {
      this.normalCount = await this.getCount('Y')
    },
    async getPartRestockCount() {
      this.partRestockCount = await this.getCount('P')
    },
    async getCount(restockStatus) {
      const params = {
        curPag: 1,
        pageSize: 20,
        restockStatus,
        amzReplenishmentCode: this.amzReplenishmentCode,
      }
      const res = await this.$api
        .ecomAmzReplenishmentDetailListByScmFbaApi(params)
        .catch(() => null)
      return res?.body?.count || 0
    },
    async reset() {
      this.searchChange()
    },
  },
}
</script>
<style lang="scss" scoped>
.search-container {
  .search-tabs {
    display: flex;
    align-items: center;
    .search-tab {
      font-size: 14px;
      line-height: 28px;
      padding: 0px 12px;
      color: #2e2e2e;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      .badge {
        margin-left: 5px;
        font-weight: 400;
        color: #707070;
        background-color: rgba(0, 0, 0, 0.07);
        padding: 3px 7px;
        font-size: 12px;
        border-radius: 10px;
      }
    }
    .search-tab:hover {
      color: #000;
      border-bottom-color: rgba(0, 0, 0, 0.1);
    }
    .search-tab.active {
      color: #000;
      font-weight: 600;
      border-bottom-color: $color-success;
      .badge {
        font-weight: 600;
      }
    }
  }
}
</style>
